module.exports = new __parcel__URL__("space_elixir_pack_reward.10f7c556.png").toString();